import { useState } from 'react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { getLocalLogo, prepareLogo, saveLocalLogo } from '../lib/receipt';

export default function ReceiptLogoSettings({ user }) {
  const [logo, setLogo] = useState(() => getLocalLogo(user.id));
  const [busy, setBusy] = useState(false);
  return <section className="rounded-2xl bg-card border border-border p-5 space-y-3">
    <h2 className="font-heading font-semibold">Logo pada bukti transaksi</h2>
    <p className="text-sm text-muted-foreground">Logo ditampilkan pada bukti sukses maupun gagal, termasuk PNG dan PDF. Tersimpan untuk akun ini di browser ini.</p>
    {logo && <img src={logo} alt="Logo warung Anda" className="h-24 max-w-full object-contain rounded-lg bg-white p-2" />}
    <label htmlFor="receipt-logo" className="block text-sm font-medium">Unggah logo (PNG, JPEG, WebP · maksimal 2 MB)</label>
    <input id="receipt-logo" type="file" accept="image/png,image/jpeg,image/webp" disabled={busy} className="block w-full text-sm" onChange={async e => {
      const file = e.target.files?.[0]; e.target.value = '';
      if (!file) return;
      setBusy(true);
      try { const image = await prepareLogo(file); saveLocalLogo(user.id, image); setLogo(image); toast.success('Logo bukti tersimpan di browser ini.'); }
      catch (err) { toast.error(err.message || 'Logo gagal disimpan. Penyimpanan browser mungkin penuh.'); }
      finally { setBusy(false); }
    }} />
    {busy && <p role="status" className="text-sm">Memproses logo…</p>}
    {logo && <Button variant="outline" disabled={busy} onClick={() => { try { saveLocalLogo(user.id, ''); setLogo(''); } catch { toast.error('Logo gagal dihapus.'); } }}>Hapus logo</Button>}
  </section>;
}
